import { ExternalLink, FileText, Network, Palette, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/useAuth";
import { authEnabled } from "../auth/config";

// Admin Documentation page. The READMEs open read-only in a new tab (raw markdown, copied to
// public/docs by copy-docs.mjs); Architecture opens in a new tab; Case Study and Design System
// navigate in-app.

export function DocsPage() {
  // authEnabled is a build-time constant, so branching before any hook is safe.
  if (!authEnabled) return <DocsNotice body="Sign-in isn't configured in this build." />;
  return <DocsPageInner />;
}

function DocsNotice({ body }: { body: string }) {
  return (
    <div className="wrap section">
      <p className="eyebrow">Admin · Documentation</p>
      <h1 className="display" style={{ fontSize: 34, marginTop: 8 }}>
        Documentation
      </h1>
      <p className="section-sub">{body}</p>
    </div>
  );
}

function DocsPageInner() {
  const { isAdmin } = useAuth();
  if (!isAdmin) return <DocsNotice body="This page is for the site admin. Please sign in." />;
  return (
    <div className="wrap section docs-page">
      <p className="eyebrow">Admin · read-only references</p>
      <h1 className="display" style={{ fontSize: 34, marginTop: 8 }}>
        Documentation
      </h1>
      <div className="docs-list">
        <p className="docs-group mono">Project docs</p>
        <a className="docs-item" href="/docs/infra.md" target="_blank" rel="noopener">
          <FileText size={15} /> Infrastructure
          <ExternalLink size={13} className="docs-ext" />
        </a>
        <a className="docs-item" href="/docs/website.md" target="_blank" rel="noopener">
          <FileText size={15} /> Website
          <ExternalLink size={13} className="docs-ext" />
        </a>
        <a className="docs-item" href="/docs/app.md" target="_blank" rel="noopener">
          <FileText size={15} /> App
          <ExternalLink size={13} className="docs-ext" />
        </a>
        <div className="docs-sep" />
        <p className="docs-group mono">In-app</p>
        <a className="docs-item" href="/architecture" target="_blank" rel="noopener">
          <Network size={15} /> Architecture
          <ExternalLink size={13} className="docs-ext" />
        </a>
        <Link className="docs-item" to="/app">
          <Sparkles size={15} /> Case Study
        </Link>
        <Link className="docs-item" to="/design-system">
          <Palette size={15} /> Design System
        </Link>
      </div>
    </div>
  );
}
